import type { AdminInvitationDisplayStatus } from '@/features/invitations/types/adminInvitation';
import type { badgeVariants } from '@/shared/components/ui/badge';
import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { type VariantProps, cva } from 'class-variance-authority';

export const ADMIN_INVITATIONS_KEY = 'admin-invitations';
export const ADMIN_INVITATIONS_STALE_TIME = 60_000;

export const ADMIN_INVITATION_STATUS_LABELS: Record<
  AdminInvitationDisplayStatus,
  MessageDescriptor
> = {
  pending: msg`Pending`,
  expired: msg`Expired`,
  accepted: msg`Completed`,
  cancelled: msg`Cancelled`,
};

export const ADMIN_INVITATION_UNKNOWN_STATUS_LABEL = msg`Unknown status`;

export const ADMIN_INVITATION_STATUS_TONES: Record<
  AdminInvitationDisplayStatus,
  VariantProps<typeof badgeVariants>['variant']
> = {
  pending: 'outline',
  expired: 'warning',
  accepted: 'success',
  cancelled: 'muted',
};

export const adminInvitationRowEmailVariants = cva('break-all', {
  variants: {
    hasDisplayName: {
      true: 'text-muted-foreground text-xs',
      false: 'font-medium text-sm',
    },
  },
});
